var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Reproductor',{attrs:{"msg":"Lección #4","audio2":"../mp3/SecundariaC/04SC.mp3","cover":"../img/10.jpg","name":"Secundaria C"}}),_c('Buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }